import React from 'react';
import { profile } from '../mock';
import { ArrowUp } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#07111f] text-white border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div>
          <div className="font-display text-xl">{profile.name}</div>
          <div className="text-[11px] tracking-[0.3em] uppercase text-[#c9a961] mt-1">
            Technical Lead · QA · Business Analysis
          </div>
        </div>
        <div className="flex items-center gap-6 text-sm text-white/60">
          <a href={`mailto:${profile.email}`} className="hover:text-[#c9a961] transition-colors">{profile.email}</a>
          <a href={profile.linkedin} target="_blank" rel="noreferrer" className="hover:text-[#c9a961] transition-colors">LinkedIn</a>
          <a href="#top" className="inline-flex items-center gap-2 hover:text-[#c9a961] transition-colors">
            Back to top <ArrowUp size={14} />
          </a>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 text-xs text-white/40 flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} {profile.name}. All rights reserved.</span>
          <span>Crafted with attention to detail.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
